// formSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DataTableUpdatedState {
  isDataTableUpdated: boolean;
}

const initialState: DataTableUpdatedState = {
  isDataTableUpdated: false,
};

export const dataTableUpdatedSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setDataTableUpdated: (state, action: PayloadAction<boolean>) => {
      state.isDataTableUpdated = action.payload;
    },
  },
});

export const { setDataTableUpdated } = dataTableUpdatedSlice.actions;

export default dataTableUpdatedSlice.reducer;
